export const DBN_DOMAIN_ACCOUNT_MAPPINGS_RESET_STATE = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_RESET_STATE';
export const DBN_DOMAIN_ACCOUNT_MAPPINGS_CURRENT_ITEM = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_CURRENT_ITEM';

export const DBN_DOMAIN_ACCOUNT_MAPPINGS_REQUEST_LOADING = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_REQUEST_LOADING';
export const DBN_DOMAIN_ACCOUNT_MAPPINGS_REQUEST_SUCCESS = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_REQUEST_SUCCESS';
export const DBN_DOMAIN_ACCOUNT_MAPPINGS_REQUEST_FAILED = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_REQUEST_FAILED';

export const DBN_DOMAIN_ACCOUNT_MAPPINGS_CURRENT_ACTION = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_CURRENT_ACTION';
export const DBN_DOMAIN_ACCOUNT_MAPPINGS_RESET_ACTION = 'DBN_DOMAIN_ACCOUNT_MAPPINGS_RESET_ACTION';